import { Question } from '@estercare/ester-shared'

// Pre-compiled regexes for known validation patterns (avoids building RegExp from variable)
const VALIDATION_REGEXES: Record<string, RegExp> = {
  '^(0|[1-9][0-9]?|1[0-9][0-9]|2[0-9][0-9])$': /^(0|[1-9][0-9]?|1[0-9][0-9]|2[0-9][0-9])$/,
  '^[0-9/ ]+$': /^[0-9/ ]+$/,
}

/**
 * Custom hook for validating screening question answers
 * @param question The current question object
 * @returns A validation object with the validation result and helper functions
 */
export const useScreeningAnswerValidation = (question: Question | null) => {
  const isValid = (): boolean => {
    if (!question) return false

    // A valid answer either isn't required or meets all requirements
    return !isRequired() || (hasAnswer() && meetsRegexValidation())
  }

  const isRequired = (): boolean => {
    return !!question?.metadata?.validation?.required
  }

  const meetsRegexValidation = (): boolean => {
    if (!question) return false

    const regexPattern = question.metadata?.validation?.regex
    if (!regexPattern) return true

    const primaryAnswer = question.answer?.[0] || ''
    const compiled = VALIDATION_REGEXES[regexPattern]
    if (!compiled) return true
    return compiled.test(primaryAnswer)
  }

  const hasAnswer = (): boolean => {
    if (!question) return false

    const answers = question.answer || []
    const primaryAnswer = answers[0] || ''

    return answers.length > 0 && primaryAnswer !== ''
  }

  return {
    isValid: isValid(),
    isRequired: isRequired(),
    hasAnswer: hasAnswer(),
    meetsRegexValidation: meetsRegexValidation(),
  }
}
